export enum OfficialRole {
    referee = "referee",
    assistant = "assistant",
    fourthOfficial = "fourthOfficial",
    observer = "observer",
}
